import React, { useContext, useEffect, useRef, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { LessonMode } from '../../../Constants';
import { AlchemieInteractiveFrame } from 'alchemie-activity-frame';
import Guideline from '../tools/Guideline';
import HtmlComponent from '../HtmlComponent';
import OptionalImage from '../OptionalImage';
import useStyleEvents from '../../../hooks/useStyleEvents';
import PrintQuestionNumber from './PrintQuestionNumber';
import UtilsService from '../../services/UtilsService';
import responseService from '../../services/ResponseService';
import { register } from '../../../i18n';

const t = register('GlobalQuestionLabels');

const StandaloneAlchemieItem = observer(({ lessonElementId }) => {
  const {
    lessonManager,
    responseManager,
    toolbarManager
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const textBody = model.questionText || '';
  const [shouldRenderFrame, setShouldRenderFrame] = useState(false);
  const [cachedParams, setCachedParams] = useState({});
  const lessonElementState = responseManager.getLessonElementState(lessonElementId);
  const readOnly = (lessonElementState && lessonElementState.readOnly) || lessonManager.isReadOnly;
  if (!lessonElementState) {
    return (<div className='standalone-alchemie-item' />);
  }

  useStyleEvents(lessonElementId);
  let startString = '';
  let goal = '';

  if (!UtilsService.isNullOrEmpty(lessonElementState.currentResponseAnswer.goal)){
    goal = lessonElementState.currentResponseAnswer.goal;
  } 
  
  if (!UtilsService.isNullOrEmpty(model.startCode)) {
    startString = model.startCode;
  }
  

  let params = {};
  if (!UtilsService.isNullOrEmpty(model.config)) {
    try {
      params = JSON.parse(model.config);
    } catch (e) {
      console.error('Failed to parse config JSON:', e);
    }
  }

  if(!UtilsService.isNullOrEmptyOrUndefined(goal)) {
    params.loadedConfig = goal
  }

  if(readOnly) {
    params.readOnly = true;
  }

  useEffect(() => {
    setShouldRenderFrame(false);
      const timer = setTimeout(() => {
        setShouldRenderFrame(true);
      }, 40);
    setCachedParams(params);
    return () => clearTimeout(timer);

  }, [lessonManager.currentLessonElementId, readOnly]);


  const updateMessage = (e) => {
    if (e.data.type === 'configuration') {
        responseService.responseChangeHandler(e.data.configuration, lessonElementId);
        console.log(e.data.configuration);
    }
  };

  return (
    <div  className='standalone-alchemie-item-question'>
      {toolbarManager.isGuidelineOpen && <Guideline lessonElementId={lessonElementId} />}
      <div className='test-item-question standalone-alchemie-item'>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && <PrintQuestionNumber model={model} />}
        <HtmlComponent htmlStr={textBody} />
      </div>
      <OptionalImage model={model} runtime={true} />
      <div className='test-item-answers'>
      <div className='alchemieToolWrapper'>
       { shouldRenderFrame && <AlchemieInteractiveFrame
            frameClass=''
            onInteractiveMessage={updateMessage}
            size='medium'
            src={model.alchemieUrl}
            start={startString}
            params={cachedParams}
        /> }
        </div>
      </div>
    </div>
  );
});

export default StandaloneAlchemieItem; 